export const environment = {
  // Variávels de controle
  production: false,
  idSystem: 2,
  // Variáveis de configuração do FloatMenu no modo Adicionar
  floaterLista: {
    iconClass: 'fa fa-plus',
    activeIconClass: 'fa fa-plus',
    label: 'Adicionar novo',
    toggle: 'hover',
    placment: 'br',
    effect: 'mfb-slidein'
  },

  // Variáveis de configuração do FloatMenu no modo Visualizar
  floaterGestao: {
    iconClass: 'fa fa-bars',
    activeIconClass: 'fa fa-bars',
    toggle: 'hover',
    placment: 'br',
    effect: 'mfb-slidein',
    buttons: []
  },

  URL_WEBCOMPONENT_SAFE2PAY: {
    link: `Asset/webcomponent/safe2pay/safe2pay-form.js?v=${new Date().getTime()}`,
    localhost: `https://d-acsafeweb.safewebpss.com.br/Asset/webcomponent/safe2pay/safe2pay-form.js?v=${new Date().getTime()}`
  },

  URL_WEBCOMPONENT_AGENDAMENTO: {
    link: `Asset/webcomponent/agendamento/agendamento-webcomponent.js?v=${new Date().getTime()}`,
    localhost: `https://d-acsafeweb.safewebpss.com.br/Asset/webcomponent/agendamento/agendamento-webcomponent.js?v=${new Date().getTime()}`
  },

  // id utilizado para buscar os contatos comerciais
  SITE_ID: 2, 
  
  // Variáveis para controle dos endpoints
  ENDPOINTS_DEBUG: [
    //'Service/Microservice/GerenciamentoAC/Autenticacao/api/Authentication'
  ],
  
  API_ENDPOINT_VIACEP: { link: 'https://viacep.com.br/ws', external: true },
  API_ENDPOINT_MUNICIPIOS: { link: 'https://servicodados.ibge.gov.br/api/v1', external: true },
  API_ENDPOINT_GEOLOCALIZACAO: { link: 'https://maps.googleapis.com/maps', external: true },
  API_ENDPOINT_CONTADORPARCEIRO: { link: 'https://gestao.contadorparceirosafeweb.com.br/api-externa/ContadorParceiro/LocalizaContadorParceiro', external: true },
  API_ENDPOINT_AUTENTICACAO_AUTH: { link: 'Service/Microservice/GerenciamentoAC/Autenticacao/api/Authentication', localhost: 'http://localhost:24257/api/Authentication', external: true },
  API_ENDPOINT_AUTENTICACAO_SESSION: { link: 'Service/Microservice/GerenciamentoAC/Autenticacao/api/SessionManager', localhost: 'http://localhost:24257/api/SessionManager', external: false },
  API_ENDPOINT_AUTENTICACAO_PREFERENCE: { link: 'Service/Microservice/GerenciamentoAC/Autenticacao/api/PreferencesManager', localhost: 'http://localhost:24257/api/PreferencesManager', external: false },
  API_ENDPOINT_CAPTURAMANUAL: { link: 'Service/Microservice/GerenciamentoAC/CapturaFotoManual', localhost: 'http://localhost:62953', external: false },
  API_ENDPOINT_CONFERENCIA: { link: 'Service/Microservice/GerenciamentoAC/Conferencia', localhost: 'http://localhost:58747', external: false },
  API_ENDPOINT_DASHBOARD: { link: 'Service/Microservice/GerenciamentoAC/Dashboard', localhost: 'http://localhost:52092', external: false },
  API_ENDPOINT_DOCUMENTOFISCAL: { link: 'Service/Microservice/GerenciamentoAC/DocumentoFiscal', localhost: 'http://localhost:52704', external: false },
  API_ENDPOINT_LOGGER: { link: 'Service/Microservice/GerenciamentoAC/Logger', localhost: 'http://localhost:55417', external: true },
  API_ENDPOINT_NOTIFICACAOEVENTO: { link: 'Service/Microservice/GerenciamentoAC/NotificacaoEvento', localhost: 'http://localhost:53195', external: false },
  API_ENDPOINT_RELATORIOS: { link: 'Service/Microservice/GerenciamentoAC/Relatorio', localhost: 'http://localhost:53253', external: false },
  API_ENDPOINT_RELATORIOS_SEGREGADO: { link: 'Service/Microservice/GerenciamentoAC/Relatorios', localhost: 'http://localhost:53253', external: false },
  API_ENDPOINT_RENOVACAO: { link: 'Service/Microservice/GerenciamentoAC/Renovacao', localhost: 'http://localhost:55210', external: false },
  API_ENDPOINT_USUARIO: { link: 'Service/Microservice/GerenciamentoAC/Usuario', localhost: 'http://localhost:6734', external: false },
  API_ENDPOINT_USUARIO_TERMO_RESPONSABILIDADE: { link: 'Service/Microservice/GerenciamentoAC/Usuario/Recursos/termo_responsabilidade.pdf', external: false },
  API_ENDPOINT_VALIDACAOEXTERNA: { link: 'Service/Microservice/GerenciamentoAC/ValidacaoExterna', localhost: 'http://localhost:53169', external: false },
  API_ENDPOINT_CONTROLEPROTOCOLO: { link: 'Service/Microservice/GerenciamentoAC/ControleProtocolo', localhost: 'http://localhost:52296', external: false },
  API_ENDPOINT_ANTIFRAUDE: { link: 'Service/Microservice/GerenciamentoAC/Antifraude', localhost: 'http://localhost:62515', external: false },
  API_ENDPOINT_SAFE2PAY: { link: 'Service/Microservice/Shared/Safe2Pay', localhost: 'http://localhost:55371', external: false },
  API_ENDPOINT_ENTIDADESAFE2PAY: { link: 'Service/Microservice/GerenciamentoAC/EntidadeSafe2Pay', localhost: 'http://localhost:50219', external: false },
  API_ENDPOINT_SOLICITACAO: { link: 'Service/Microservice/GerenciamentoAC/Solicitacao', localhost: 'http://localhost:58394', external: false },
  API_ENDPOINT_PRODUTO: { link: 'Service/Microservice/GerenciamentoAC/Produto', localhost: 'http://localhost:58427', external: false },
  API_ENDPOINT_PARTNER: { link: 'Service/Microservice/Shared/Partner', localhost: 'http://localhost:51976', external: false },
  API_ENDPOINT_PARCEIRO: { link: 'Service/Microservice/GerenciamentoAC/Parceiro', localhost: 'http://localhost:63896', external: false },
  API_ENDPOINT_CATALOGO: { link: 'Service/Microservice/GerenciamentoAC/Catalogo', localhost: 'http://localhost:61847', external: false },
  API_ENDPOINT_PRODUTOS_CATALOGO: { link: 'Service/Microservice/GerenciamentoAC/CatalogoProduto', localhost: 'http://localhost:58431', external: false },
  // Externos
  API_ENDPOINT_CONSULTAPREVIA: { link: 'Service/Microservice/Shared/ConsultaPrevia', external: false },
  API_ENDPOINT_FIREBASE: { link: 'Service/Microservice/GerenciamentoAC/Firebase', localhost: 'http://localhost:49219', external: false },
  API_ENDPOINT_IBGE: { link: 'Service/Microservice/Shared/Ibge', localhost: 'http://localhost:53840', external: false },
  API_ENDPOINT_MATCHBIOMETRIAS: { link: 'Service/Microservice/Shared/MatchBiometry', external: false },
  API_ENDPOINT_PERMISSAO: { link: 'Service/Microservice/GerenciamentoAC/Usuario', localhost: 'http://localhost:6734', external: false },
  API_ENDPOINT_AUTORIDADEREGISTRO: { link: 'Service/Microservice/GestaoAC/AutoridadeRegistro', localhost: 'http://localhost:56516', external: false },
  WEBCOMPONENT_AGENDAMENTO: { link: 'Asset/js', localhost: 'https://d-acsafeweb.safewebpss.com.br/Asset/js' },
  // Configuração do firebase
  firebaseConfig: {
    apiKey: 'AIzaSyBij0GjY5giw4yp2edL-VIui-5YyEPtRLU',
    authDomain: 'gestao-ac.firebaseapp.com',
    databaseURL: 'https://gestao-ac.firebaseio.com',
    projectId: 'gestao-ac',
    storageBucket: 'gestao-ac.appspot.com',
    messagingSenderId: '245213018105'
  }
};
